import React from "react";

interface SliderProps {
  min: number;
  max: number;
  value: number;
  onChange: (value: number) => void;
  className?: string;
  vertical?: boolean;
  step?: number;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onTouchStart?: () => void;
  onTouchEnd?: () => void;
}

export const Slider: React.FC<SliderProps> = ({
  min,
  max,
  value,
  onChange,
  className = "",
  vertical = false,
  step = 0.01,
  onMouseEnter = () => {},
  onMouseLeave = () => {},
  onTouchStart = () => {},
  onTouchEnd = () => {},
}) => {
  return (
    <input
      type="range"
      step={step}
      min={min}
      max={max}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className={`
        appearance-none bg-zinc-700 rounded-full
        ${vertical ? "writing-mode-vertical" : "h-2"}
        ${className}
      `}
      style={
        vertical
          ? {
              writingMode: "vertical-lr",
              width: "8px",
            }
          : undefined
      }
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    />
  );
};
